import classNames from 'classnames';

import { Paragraph } from '../Text';

import style from './bulleted-list.module.css';

interface BulletedListProps {
  className?: string;
  dense?: boolean;
  items: string[];
}

const BulletedList = ({
  className,
  dense,
  items,
}: BulletedListProps) => {
  if (!items.length) {
    return null;
  }

  return (
    <ul
      className={classNames(
        style.list,
        { [style.listDense]: dense },
        className,
      )}
    >
      {items.map(item => {
        return (
          <li key={item}>
            <Paragraph fontSize={15}>
              {item}
            </Paragraph>
          </li>
        );
      })}
    </ul>
  );
};

export default BulletedList;
